<template>
  <v-card flat>
    <v-card-text>
      {{ isCompanyManager ? $t('downgradeText') : $t('promoteText') }}
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <disabled-user-button>
        <v-btn
          slot-scope="{isDisabledForUser}"
          :color="isCompanyManager ? 'warning' : 'primary'"
          :loading="isLoading"
          :disabled="isDisabledForUser || isLoading"
          style="margin: 0"
          @click.native="toggleEmployeePromote"
        >
          {{ isCompanyManager ? $t('downgrade') : $t('promote') }}
        </v-btn>
      </disabled-user-button>

    </v-card-actions>
  </v-card>
</template>

<script>
import CompanyApi from '@/api/CompanyApi'

import { mapGetters, mapActions } from 'vuex'
import DisabledUserButton from '@/components/global-components/disabledUserButton/disabledUserButton'

export default {
  name: 'EmployeeSettingsRole',
  components: { DisabledUserButton },
  data () {
    return {
      isLoading: false,
      employee: null
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee']),
    isCompanyManager () {
      if (this.currentEmployee) {
        return this.currentEmployee.role === 'company_manager'
      }
    }
  },
  methods: {
    ...mapActions('employee', ['getEmployee']),
    actionByRole (action) {
      return CompanyApi[action](this.currentEmployee.id)
    },
    async toggleEmployeePromote () {
      this.isLoading = true
      try {
        const response = await this.actionByRole(this.isCompanyManager ? 'downgradeEmployee' : 'assignEmployee')
        this.$notification(response)
        await this.updateEmployeeStore()
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    },
    updateEmployeeStore () {
      return this.getEmployee({
        companyId: this.currentEmployee.company_id,
        employeeId: this.currentEmployee.id,
        force: true
      })
    }
  },
  i18n: {
    messages: {
      en: {
        headline: 'Promotion',
        promote: 'Promote',
        promoteText: 'Promote this employee to a company manager. Attention: Employee will be able to change most of the companies settings. This includes managing (creating, deleting, changing) employees and company data.',
        downgradeText: 'This action deprives the employee of all management permissions. The employee can only change his own settings, such as email, password, language and track his working time. ',
        downgrade: 'Downgrade'
      },
      tr: {
        headline: 'Terfi',
        promote: 'Terfi',
        promoteText: 'Bu çalışanı şirket yöneticisi olarak terfi ettir. Uyarı: çalışan birçok şirket ayarı değiştirebilir olacaktır. Buna şirket ve çalışan ayarlarını yönetme (yaratma, silme, güncelleme) dahildir.',
        downgradeText: 'Bu işlem çalışanın tüm yönetsel yetkilerini kaldıracaktır. Çalışan yalnızca e-posta, şifre ve dil gibi ayarları değiştirebilecek ve zaman takibi yapabilecektir. ',
        downgrade: 'Seviye Düşürme'
      },
      de: {
        headline: 'Beförderung/Degradierung',
        promote: 'Befördern',
        promoteText: 'Diesen Mitarbeiter zu einem Firmenmanager befördern. Vorsicht: Der Mitarbeiter ist anschließend befähigt die meisten Firmeneinstellungen zu ändern. Dies beinhaltet das Management von Mitarbeitern und der Firmendaten.',
        downgradeText: 'Durch diese Aktion werden dem Mitarbeiter alle Managementfähigkeiten entzogen. Der Mitarbeiter kann nur noch seine eigenen Einstellungen, wie zum Beispiel Email, Passwort, Sprache ändern und seine Arbeitszeit messen. ',
        downgrade: 'Downgrade'
      },
      ru: {
        headline: 'Продвижение',
        promote: 'Повысить',
        promoteText: 'Повышие должности сотрудника до менеджера компании. Внимание: Сотрудник сможет изменить большинство настроек компании. Это включает в себя управление (создание, удаление, изменение) сотрудников и данные компании.',
        downgradeText: 'Это действие лишает сотрудника всех прав на управление. Сотрудник может изменять только свои настройки, такие как электронная почта, пароль, язык и отслеживание его рабочего времени.',
        downgrade: 'Понизить'
      }
    }
  }
}
</script>
